<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="部门名称：" prop="deptName">
            <el-input v-model="query.deptName" placeholder="请输入部门名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="权限：" prop="name">
            <el-select v-model="query.authority" placeholder="请选择" clearable size="small">
              <el-option label="商城价格查看权限" :value="1"></el-option>
              <el-option label="学习权限" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.deptStatus" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新建部门</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list">
        <el-table-column label="部门名称" prop="deptName" align="center" fixed>
        </el-table-column>
        <el-table-column label="权限" prop="" align="center" fixed>
          <template slot-scope="{row}">
            <span v-if="row.canLookGoodsPrice">商城价格查看权限</span>
            <span v-if="row.canLookGoodsPrice && row.canStudyCourse">、</span>
            <span v-if="row.canStudyCourse">学习权限</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdTime" align="center" sortable>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" align="center" sortable>
        </el-table-column>
        <el-table-column label="状态" prop="deptStatus" align="center" width="200">
          <template slot-scope="{row}">
            <el-switch v-model="row.deptStatus" active-text="启用" inactive-text="禁用" :active-value="1"
              :inactive-value="0" @change="handleState(row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="" align="center">
          <template slot-scope="{row}">
            {{row.operatedPO.realName}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="250">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row,0)">编辑</el-button>
            <!-- <el-button type="text" @click="handleUpdate(row,1)">日志记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <banner-add ref="bannerAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
  import bannerAdd from './add'
  import sysDeptApi from '@/api/sys/sysDept'
  import Pagination from '@/components/Pagination'

  export default {
    components: {
      Pagination,
      bannerAdd
    },
    data() {
      return {
        list: [],
        total: 0,
        listLoading: true,
        query: {
          pageNo: 1,
          pageSize: 10,
          // canLookGoodsPrice: 1,
          // canStudyCourse: 1
        },
      }
    },
    created() {
      this.doQueryList({
        pageNo: 1
      })
    },
    methods: {
      handleFilter() {
        this.query = {
          pageNo: 1,
          pageSize: 10,
          // canLookGoodsPrice: 1,
          // canStudyCourse: 1
        }
        this.doQueryList({
          pageNo: 1
        })
      },
      // 修改状态
      handleState(row) {
        sysDeptApi.update(row)
      },
      /**
       * 分类筛选
       */
      handleClick() {
        this.doQueryList({
          pageNo: 1
        })
        // console.log("activeName: ",this.activeName);
      },
      /**
       * 触发搜索操作
       */
      handleQuery() {
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 执行列表查询
       */
      doQueryList({
        pageNo,
        pageSize
      }) {
        if (pageNo) {
          this.query.pageNo = pageNo
        }
        if (pageSize) {
          this.query.pageSize = pageSize
        }
        let query = {
          ...this.query
        }
        if (this.query.authority) {
          if(this.query.authority == 1){
            query.canLookGoodsPrice = 1
          }else{
            delete query.canLookGoodsPrice
          }
          if(this.query.authority == 2){
            query.canStudyCourse = 1
          }else{
            delete query.canStudyCourse
          }
        }
        delete query.authority
        // this.query.displayPosition=this.activeName
        this.listLoading = true
        return sysDeptApi.fetchList(query)
          .then(({
            data
          }) => {
            console.log("data: ", data);
            this.list = data.list
            this.total = data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      },
      /**
       * 打开新建表单
       */
      handleCreate() {
        this.$refs.bannerAdd.handleCreate()
      },
      /**
       * 打开查看表单
       */
      handleShow(row) {
        this.$refs.bannerShow.handleShow(row.id)
      },
      /**
       * 打开编辑表单
       */
      handleUpdate(row,type) {
        if(type){
          this.$router.push("/log/log?type=90&id=" + row.id);
        }else{
          this.$refs.bannerAdd.handleUpdate(row)
        }
      }
    }
  }
</script>
